import TransactionDetails from './TransactionDetails';
import TransactionDetailsModal from './modal';

export { TransactionDetails };

export default TransactionDetailsModal;
